export class BaseStore {
    constructor() {
    }
}
